var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-card",
    { attrs: { "no-body": "", header: _vm.header } },
    [
      _c(
        "b-card-body",
        [
          _c(
            "c-switch",
            _vm._b(
              {
                attrs: { id: "enabled", color: "primary", label: "" },
                model: {
                  value: _vm.enabled,
                  callback: function ($$v) {
                    _vm.enabled = $$v
                  },
                  expression: "enabled",
                },
              },
              "c-switch",
              _vm.labelIcon,
              false
            )
          ),
          _vm._v(_vm._s(_vm.$t("admin.integration_kenna_enable")) + "\n    "),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "kenna-cadence",
              label: _vm.$t("admin.synchronization_cadence_minutes"),
              "input-group-size": "mb-3",
              rules: "required",
              type: "number",
              lazy: "true",
            },
            model: {
              value: _vm.cadence,
              callback: function ($$v) {
                _vm.cadence = $$v
              },
              expression: "cadence",
            },
          }),
          _c("p", { staticClass: "text-muted" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$t("admin.synchronization_cadence_restart_required")
                ) +
                "\n    "
            ),
          ]),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "kenna-connector.id",
              label: _vm.$t("admin.integration_kenna_connector_id"),
              "input-group-size": "mb-3",
              rules: "required",
              type: "text",
              lazy: "true",
            },
            model: {
              value: _vm.connectorId,
              callback: function ($$v) {
                _vm.connectorId = $$v
              },
              expression: "connectorId",
            },
          }),
          _c("b-validated-input-group-form-input", {
            attrs: {
              id: "kenna-token",
              label: _vm.$t("admin.token"),
              "input-group-size": "mb-3",
              rules: "required",
              type: "password",
              lazy: "true",
            },
            model: {
              value: _vm.token,
              callback: function ($$v) {
                _vm.token = $$v
              },
              expression: "token",
            },
          }),
        ],
        1
      ),
      _c(
        "b-card-footer",
        [
          _c(
            "b-button",
            {
              staticClass: "px-4",
              attrs: { variant: "outline-primary" },
              on: { click: _vm.saveChanges },
            },
            [_vm._v(_vm._s(_vm.$t("message.update")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }